// gform.addAction('gform/post_render', function(formId, currentPage){
//     console.log('test')
//     var errorTimeout;

//     var $errors = $("#gform_"+formId).find('.gfield_error');

//     $errors.each(function(){
//         $errorField.on('mouseenter', function(){
//             clearTimeout(errorTimeout);

//             errorTimeout = setTimeout(function(){
//                 $errorField.fadeOut(200);
//             }, 3000);
//         });

//         $errorField.on('mouseleave', function(){
//             clearTimeout(errorTimeout);
//             //$errorField.fa
//         })
//     })
// });

// console.log(gform);
jQuery(document).ready(function ($) {
    document.addEventListener('gform/post_render', function (event) {
        const formId = event.detail.formId;
        const page = event.detail.currentPage;
        console.log("test");

        const $form = $('#gform_' + formId);
        $form.find('.gfield_error').each(function () {
            var $errorField = $(this).find('.validation_message');
            var errorTimeout;

            $(this).on('mouseenter', function () {
                clearTimeout(errorTimeout);
                $errorField.fadeIn(200);

                errorTimeout = setTimeout(function () {
                    $errorField.fadeOut(200);
                }, 2000);
            });
        })
    })
})

